import React from "react"
import Slider from "react-slick"

import t from "../locale"

const OfficesSliderSquareTwo = ({ lang }) => {
  const officesSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    fade: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <Slider {...officesSlider}>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>{t("4 tenants (floor 2-8)", lang)}</h4>
              <p>
                746,50{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/US_Two/US2_4Tenants_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom offices-schema__wrapper-bottom--one-col">
            <ul>
              <li>
                {t("Tenant", lang)} 01 – 23 {t("workplaces", lang)}
              </li>
              <li>
                {t("Tenant", lang)} 02 – 14 {t("workplaces", lang)}
              </li>
              <li>
                {t("Tenant", lang)} 03 – 20 {t("workplaces", lang)}
              </li>
              <li>
                {t("Tenant", lang)} 04 – 14 {t("workplaces", lang)}
              </li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-SQUARE-Two-4-tenants_v2-en.pdf")
                  : require("../assets/pdf/UNITY-SQUARE-Two-4-tenants_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>{t("Modern version (floor 2-8)", lang)}</h4>
              <p>
                746,50{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>55 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/US_Two/US2_modern_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("3 office rooms / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("6 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("Relax and lounge area", lang)}</li>
              <li>{t("4 storage rooms", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-SQUARE-Two-modern_v2-en.pdf")
                  : require("../assets/pdf/UNITY-SQUARE-Two-modern_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>{t("Traditional version (floor 2-8)", lang)}</h4>
              <p>
                746,50{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>114 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/US_Two/US2_traditional_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("2 office rooms / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("6 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("2 storage rooms", lang)}</li>
              <li>{t("Relax area", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-SQUARE-Two-traditional_v2-en.pdf")
                  : require("../assets/pdf/UNITY-SQUARE-Two-traditional_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      {/* <div>
        {lang === "en" ? (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-USquare-Two-en.jpg")}
            alt=""
          />
        ) : (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-USquare-Two-pl.jpg")}
            alt=""
          />
        )}
      </div> */}
    </Slider>
  )
}

export default OfficesSliderSquareTwo
